import { render, staticRenderFns } from "./BaseCreateBtn.vue?vue&type=template&id=37858f18&"
import script from "./BaseCreateBtn.vue?vue&type=script&lang=js&"
export * from "./BaseCreateBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports